import { Box, Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ChevronLeft } from "@material-ui/icons";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import useAuthStore from "../../../store/login/useAuthStore";

const useStyles = makeStyles((theme) => ({
  topHeader: {
    backgroundColor: "#fff",
    color: "#000",
    padding: "16px 32px 16px 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("360")]: {
      padding: "14px 14px 14px 6px",
    },
  },
}));

const TopHeader = () => {
  const classes = useStyles();
  const [navbar, setNavbar] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const name = useAuthStore((store) => store.name);
  const family = useAuthStore((store) => store.family);
  const goBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (location.pathname) {
      setNavbar(location.pathname);
    }
  }, [location.pathname]);

  return (
    <Box className={classes.topHeader}>
      <Typography variant="h3" style={{ width: "100px" }}>
        {name + " " + family}
      </Typography>
      {navbar !== "/" && (
        <Button startIcon={<ChevronLeft />} onClick={goBack}></Button>
      )}
    </Box>
  );
};
export default TopHeader;
